import { Box, Typography, useTheme } from "@mui/material";

type SumaryItemProps = {
  label: string;
  value?: number | string;
  fontWeightLabel: number;
  colorLabel: string;
  colorValue: string;
};
export const SumaryItem = ({
  label,
  value,
  fontWeightLabel,
  colorLabel,
  colorValue
}: SumaryItemProps) => {
  const theme = useTheme();
  return (
    <Box display="flex" justifyContent="space-between" alignItems="center">
      <Typography variant="body1" fontWeight={fontWeightLabel} sx={{ color: colorLabel }}>
        {label}
      </Typography>
      <Typography fontWeight={600} sx={{ color: value === "Free" ? theme.palette.success.main : colorValue }}>{value}</Typography>
    </Box>
  );
};
